module.exports = __webpack_public_path__ + "img/andreaswiedenmann.85f376a5.jpeg";